import * as RDialog from '@radix-ui/react-dialog';
import { X } from 'lucide-react';
import { cn } from '@/lib/cn';

export const Dialog = RDialog.Root;
export const DialogTrigger = RDialog.Trigger;
export const DialogClose = RDialog.Close;

export function DialogContent({ className, children, ...p }: React.ComponentProps<typeof RDialog.Content>) {
  return (
    <RDialog.Portal>
      <RDialog.Overlay className="fixed inset-0 z-40 bg-black/40 backdrop-blur-[2px] data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=open]:fade-in-0 data-[state=closed]:fade-out-0" />
      <RDialog.Content
        className={cn('fixed left-1/2 top-1/2 z-50 w-[calc(100%-2rem)] max-w-lg max-h-[90dvh] overflow-y-auto overscroll-contain -translate-x-1/2 -translate-y-1/2 rounded-lg border border-[var(--border)] bg-[var(--surface)] p-6 pr-16 shadow-elevated focus:outline-none [-webkit-overflow-scrolling:touch]', className)}
        {...p}
      >
        {children}
        <RDialog.Close className="absolute right-2 top-2 flex h-11 w-11 items-center justify-center rounded-[var(--r-sm)] text-[var(--text-muted)] hover:bg-[var(--surface-2)] focus-visible:outline focus-visible:outline-2 focus-visible:outline-[var(--blue)] focus-visible:outline-offset-2" aria-label="Закрыть">
          <X className="h-4 w-4" aria-hidden="true" />
        </RDialog.Close>
      </RDialog.Content>
    </RDialog.Portal>
  );
}

export function DialogTitle({ className, ...p }: React.ComponentProps<typeof RDialog.Title>) {
  return <RDialog.Title className={cn('min-w-0 text-lg font-semibold text-[var(--text)] [overflow-wrap:anywhere]', className)} {...p} />;
}
export function DialogDescription({ className, ...p }: React.ComponentProps<typeof RDialog.Description>) {
  return <RDialog.Description className={cn('text-sm text-[var(--text-muted)]', className)} {...p} />;
}
